import { Slider, SliderRange, SliderThumb, SliderTrack } from "@radix-ui/react-slider"

import { cn } from "@/domains/library"

export type ITokenPercentageSlider = {
  symbol: string
  imageURL: string
  decimals: number
  calculateValue: (percentage: number) => string
}

export const TokenPercentageSlider = ({
  disabled = false,
  token,
  onChange,
  value,
}: {
  disabled?: boolean
  token: ITokenPercentageSlider | null | undefined
  onChange: (amount: string) => void
  value?: number
}) => {
  return (
    <div className="w-full">
      <Slider
        className="slider-root group relative flex h-[32px] min-h-[32px] w-full touch-none select-none items-center"
        defaultValue={[0]}
        disabled={disabled}
        max={100}
        min={0}
        step={1}
        value={value !== undefined ? [value] : undefined}
        onValueChange={(percentage: number[]) => {
          onChange(token?.calculateValue(Number(percentage[0]) / 100) ?? "0")
        }}
      >
        <SliderTrack className="slider-track bg-p400 relative h-[8px] flex-grow rounded-full">
          <SliderRange className="slider-range bg-p100 absolute inset-0 h-full rounded-full" />
        </SliderTrack>
        <SliderThumb
          className={cn(
            "slider-thumb hover:bg-p100 text-t200",
            "bg-p100",
            "border-p400 border",
            "relative flex h-[24px] w-[24px] flex-col items-center justify-center ",
            "rounded-full ",
            "text-center text-[10px] ",
            "font-normal ",
            "shadow-md ",
            "focus:outline-none ",
            "focus:ring-2 focus:ring-ring focus:ring-offset-0",
          )}
        >
          {value?.toFixed(0)}
        </SliderThumb>
      </Slider>
    </div>
  )
}
